$(".calbtn").click(function() {
  $(".calendar-outer").toggleClass("showcal");
});

$(document).on('click', function(e) {
  // Check if the clicked area is not the calendar or the button to show the calendar
  if (!$(e.target).closest('.calendar-outer, .calbtn').length) {
    $('.calendar-outer').removeClass('showcal');
  }
});
